import { render, staticRenderFns } from "./folderItem.vue?vue&type=template&id=6ef2d7cf&scoped=true&"
import script from "./folderItem.vue?vue&type=script&lang=js&"
export * from "./folderItem.vue?vue&type=script&lang=js&"
import style0 from "./folderItem.vue?vue&type=style&index=0&id=6ef2d7cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2d7cf",
  null
  
)

export default component.exports